import styled from 'styled-components';

export const CabDetailsContainer = styled.div`
    margin: ${p => p.margin ? p.margin : ''};
    h4 {
        margin-bottom: 1.3rem;
    }
`;